import {autoinject} from "aurelia-framework";
import {CartService, Legals, PaymentMethod} from "../cart-service";
import {Address} from "../ui/address-form";

@autoinject()
export class Page4Confirm {

  private addressesMatch = true;

  private legals = new Legals();

  private total: number;

  private sum: number;

  private shipping: number;

  private billingAddress: Address;

  private shippingAddress: Address;

  private addressValid: boolean = false;

  private valid: boolean = false;

  private selectedPaymentMethod: string = PaymentMethod.CreditCard.toString();

  private paymentMethods: string[] = [PaymentMethod.PayPal.toString(), PaymentMethod.CreditCard.toString(), PaymentMethod.AdvancedPayment.toString()];

  private checkoutInProgress: boolean = false;

  constructor(private cartService: CartService) {
    window.scrollTo(0, 0);
  }

  attached() {
    this.checkoutInProgress = false;
    this.sum = this.cartService.getSum();

    this.total = this.cartService.getTotalAmount();

    this.shipping = this.cartService.getShippingCostAmount();

    this.cartService.getBillingAddress().then(address => {
      this.billingAddress = address
    })

    this.cartService.getShippingAddress().then(address => {
      this.shippingAddress = address
    })
  }

  timeout(ms): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async submit() {
    if (this.checkoutInProgress) {
      return;
    }

    this.checkoutInProgress = true;

    try {
      this.cartService.setPaymentMethod(this.selectedPaymentMethod);

      if (this.sum === 0) return;

      const address = this.addressesMatch ? this.shippingAddress : this.billingAddress;

      this.cartService.saveShippingAddress(this.shippingAddress);
      this.cartService.saveBillingAddress(address);
      await this.cartService.purchase();
    } catch (e) {
      console.error("error while purchase: ", e);
    } finally {
      // wait 2 seconds for the concardis-page
      await this.timeout(2000);
      this.checkoutInProgress = false;
    }
  }

  trackAddressesDoMatch(addressesMatch: boolean) {
    try {
      NY_TRACKER.trackClick({
        value: (addressesMatch).toString(),
        label: 'page5',
        action: 'addressesMatch',
        category: "GiftcardClient"
      })
    } catch (e) {
      console.log("no tracking inizialized");
    }

    this.validate();
  }

  validate(): void {
    const isShippingAddressValid = this.cartService.validateAddress(this.shippingAddress);
    const isBillingAddressValid = this.addressesMatch ? isShippingAddressValid : this.cartService.validateAddress(this.billingAddress);

    this.addressValid = isBillingAddressValid && isBillingAddressValid;
    this.valid = this.sum > 0 && this.legals.privacyConfirmed === true && this.legals.termsOfServiceConfirmed === true && this.legals.returnPolicyConfirmed === true && this.legals.legalAge === true;
  }
}